<template>
  <div class="flex align-items-center justify-content-center pt-3 pb-3">
    <PrimevueCard  class="sm:w-6 md:w-6 lg:w-5 xl:w-4">
      <template #title>FARBA</template>
      <template #subtitle ><div class="mb-3 border-solid border-1 surface-border"></div></template>
      <template #content>
          
          <form @submit.prevent="submitHandler" name="colorForm">
            <div class="field">
                <label for="color-code">Kód</label>
                <InputText class="w-full" 
                  :class="`${v$.color.code.$error ? 'bg-red-200' : ''}`"
                  :invalid="v$.color.code.$error"
                  v-model="this.color.code"
                  type="text"
                  name="color-code"
                  id="color-code"
                >
                </InputText>
                <div
                     v-for="(error, index) of v$.color.code.$errors"
                     :key="index"
                     class="text-sm font-italic text-red-400"
                >
                  {{ error.$message }}
                </div>
            </div>

            <div class="field">
              <label for="color-shade">Odtieň</label>
              <InputText class="w-full" 

                v-model="this.color.shade"
                type="text"
                name="color-shade"
                id="color-shade"
              >
              </InputText>

            </div>            

            <div class="field">
              <label for="color-hash">Farba #</label>
              <InputText class="w-full" 

                v-model="this.color.colorHash"
                type="text"
                name="color-hash"
                id="color-hash"
              >
              </InputText>
 
            </div>            

          <div class="field">
            <div class="flex align-items-center justify-content-center"> 
              <PrimevueCheckbox 
                v-model="this.color.imitation" inputId="imitation" name="imitation" :binary="true"
              />
              <label for="imitation" class="ml-2">Imitácia dreva</label>
            </div>
          </div>

            <div class="field">
              <label for="description">Popis</label>
              <PrimevueTextArea autoResize rows="1" class="w-full"
                placeholder="Tu napíš popis k farbe"
                v-model="this.color.description"
                style="text-align: left"
                name="description"
                id="description"
                >
              </PrimevueTextArea>
            </div>

            
            <div class="mt-3 mb-3 border-solid border-1 surface-border"></div>
            
            <div class="mt-2 flex flex-wrap justify-content-center gap-3">
                <PrimevueButton type="submit" label="Uložiť" text raised class="uppercase"/>
                <router-link to="/mod-stock/colors">
                      <PrimevueButton label="Zrušiť" severity="danger" text raised class="uppercase"/>
                </router-link>
            </div>
          </form>
        </template>
    
    </PrimevueCard>
  </div>

</template>


<script lang="ts">
import Security from "@/components/security";
import {store} from "@/components/store";
import notie from "notie/dist/notie";
import router from "@/router";
import PrimevueButton from 'primevue/button';
import PrimevueCheckbox from 'primevue/checkbox';
import PrimevueTextArea from "primevue/textarea";
import PrimevueCard from 'primevue/card';
import { required, helpers, minLength  } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

//const mustBe421 = (value : string) => !helpers.req(value) || value.startsWith('+421')

export default {
  name: "ColorEdit",
  components: {
      //PrimevuePassword,
      PrimevueCheckbox,
      PrimevueButton,
      PrimevueTextArea,
      PrimevueCard,
  },
  data() {
    return {
      store,
      //dialogClosedByAccept: false,
      //departOptions: [],
      color: {
        id: 0,
        code: "",
        description: "",
        shade: "",
        colorHash: "",
        imitation: false
      },

    }
  },
  setup () {
    return {
      v$: useVuelidate()
    }
  },
  validations () {
    return {
      color: {
        code: { required: helpers.withMessage('Kód nesmie byť prázdny', required),
                minLength: helpers.withMessage('Kód musí obsahovať min. 3 znaky', minLength(3)),
              },

      }
    }
  },
  methods: {
    async submitHandler() {
      const result = await this.v$.$validate()
      if (!result) {
        // notify user form is invalid
        return
      }

      const colorId = parseInt(String(this.$route.params.colorId), 10)
      //console.log('userId:', userId)
      //let depart = this.departOptions.filter(obj => obj.id == this.user.department)[0]  
      //console.log('Depart:', depart)
      const payload = {
        id: this.color.id,
        code: this.color.code,
        description: this.color.description,
        shade: this.color.shade,     
        colorHash: this.color.colorHash,   
        deleted: false,
        imitation: this.color.imitation,
      }

      let method = "POST"
      let url = "/v1/color/"
      if (colorId > 0){
        method = "PUT"
        url = "/v1/color/" + colorId
      }

      fetch(store.Api_url + url, Security.requestOptions(method, payload))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              console.log("error:", responseData.data.message);
              //this.$emit('error', responseData.data.message);
              notie.alert({
                type: 'error',
                text: responseData.data.message
              })
            } else {
              notie.alert({
                type: 'success',
                text: "Farba bola uložená"
              })
              this.color = responseData.data
              router.push("/mod-stock/colors");
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri uložení farby" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri uložení farby" + error
            })
          })


    },
    validateForm() {
      this.isSubmitted = true; // Mark the form as submitted to show validation feedback
      //this.isPhoneValid = this.user.phone.startsWith('+421');
      //if(this.isPhoneValid) {
      //  return true
      //}else{
      //  return false
      //}
    },

  },

  beforeMount() {
    //console.log("calling user")
    if (Security.requireToken()){
      store.selectModul = this.$route.path.split("/")[1]
      //if(store.user.admin===false ){
      //  router.push("/")
      //  notie.alert({
      //    type: 'error',
      //    text: "Na túto akciu nemáte oprávnenia"
      //  })
      

      if (parseInt(String(this.$route.params.colorId), 10) > 0) {
        // editing an existing color
        const colorId = String(this.$route.params.colorId)

        fetch(store.Api_url + "/v1/color/" + colorId, Security.requestOptions("GET"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                //console.log("error:", responseData.data);
                //this.$emit('error', responseData.data);
              } else {
                //console.log(responseData);
                this.color = responseData.data

              }
            })
            .catch((error) => {
              this.$emit('error', "Chyba pri načítaní farby" + error);
        })
      }


    }

  }
}
</script>



<style scoped>

</style>